import { render } from "./RegisterProdMobile.vue?vue&type=template&id=6187575b&scoped=true"
import script from "./RegisterProdMobile.vue?vue&type=script&lang=js"
export * from "./RegisterProdMobile.vue?vue&type=script&lang=js"

import "./RegisterProdMobile.vue?vue&type=style&index=0&id=6187575b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6187575b"]])

export default __exports__